import { store } from "../store";

export default function getSystemConfiguration() {
    const state = store.getState();
    let configuration = state?.SystemConfigurationReducer?.systemConfiguration;
    if (!configuration) {
        configuration = {};
    }
    return configuration;
}